import { PUBLIC_STRINGS_EN, PUBLIC_STRINGS_SW } from './publicStrings';

/** @typedef {'en' | 'sw'} AppLanguage */

const CORE_STRINGS = {
  en: {
    'lang.en': 'English',
    'lang.sw': 'Swahili',
    'lang.label': 'Language',
    'lang.switch': 'Switch language',

    'theme.appearance': 'Appearance',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.system': 'System',
    'theme.toggle': 'Light or dark mode',

    'role.owner': 'Owner',
    'role.manager': 'Manager',
    'role.employee': 'Staff',

    'topbar.dashboard': 'Dashboard',
    'topbar.openMenu': 'Open menu',
    'topbar.loggedIn': 'Logged in:',
    'topbar.session': 'Session',
    'topbar.notifications': 'Notifications',
    'topbar.unreadNotifications': '{{count}} unread notifications',
    'topbar.markAllRead': 'Mark all read',
    'topbar.noNotifications': 'No notifications yet.',
    'topbar.logout': 'Logout',
    'topbar.changePhoto': 'Change profile photo',

    'menu.overview': 'Overview',
    'menu.users': 'Branches & Team',
    'menu.usersBranch': 'My branch team',
    'menu.stock': 'Raw materials',
    'menu.orders': 'Material orders',
    'menu.factoryStock': 'Stock',
    'menu.ordersShop': 'Orders',
    'menu.stockShop': 'Stock management',
    'menu.productsAuto': 'Spare parts',
    'menu.openingStockAuto': 'Opening stock',
    'menu.manualAuto': 'User Manual',
    'menu.ordersAuto': 'Purchases',
    'menu.stockAuto': 'Inventory',
    'menu.brick': 'Production',
    'menu.pos': 'POS',
    'menu.posAuto': 'Sales',
    'menu.posFactory': 'Sales (POS)',
    'menu.printing': 'Printing & copy',
    'menu.expenses': 'Expenses',
    'menu.expensesFactory': 'Expenses',
    'menu.cash': 'Wakala cashbook',
    'menu.reports': 'Reports',
    'menu.settings': 'Settings',

    'submenu.branches-list': 'Branches',
    'submenu.users-list': 'All users',
    'submenu.users-listBranch': 'Coworkers',
    'submenu.users-add': 'Add user',
    'submenu.raw-materials-overview': 'Overview',
    'submenu.add-raw-material': 'Add materials',
    'submenu.add-raw-material-category': 'Add category',
    'submenu.factory-suppliers': 'Add suppliers',
    'submenu.orders-make': 'Order materials',
    'submenu.orders-tracking': 'Tracking status',
    'submenu.orders-makeShop': 'Make new order',
    'submenu.orders-list': 'List of orders',
    'submenu.auto-products-record': 'Record spare parts',
    'submenu.auto-products-opening': 'Opening stock',
    'submenu.auto-products-categories': 'Part categories',
    'submenu.auto-products-brands': 'Brands',
    'submenu.auto-products-units': 'Units',
    'submenu.auto-products-list': 'Parts list',
    'submenu.orders-makeAuto': 'New purchase order',
    'submenu.auto-suppliers': 'Suppliers',
    'submenu.orders-listAuto': 'Purchase history',
    'submenu.orders-trackingAuto': 'Receive & tracking',
    'submenu.shop-customer-docs': 'Quotations & invoices',
    'submenu.factory-stock-overview': 'Stock overview',
    'submenu.stock-alerts': 'Low stock alerts',
    'submenu.stock-add': 'Add product',
    'submenu.stock-list': 'Product list',
    'submenu.stock-addAuto': 'Add spare part',
    'submenu.stock-listAuto': 'Parts catalog',
    'submenu.stock-alertsAuto': 'Low stock',
    'submenu.stock-pending': 'Pending approvals',
    'submenu.pharmacy-expiry': 'Expiry & batches',
    'submenu.brick-catalog': 'Brick & tile catalog',
    'submenu.brick-production': 'Production batches',
    'submenu.damaged-products': 'Damaged stock',
    'submenu.damaged-productsAuto': 'Damaged spare parts',
    'submenu.auto-inventory': 'Inventory list',
    'submenu.pos-sale-products': 'Sale products',
    'submenu.pos-sale-productsAuto': 'New sale',
    'submenu.brick-pre-orders': 'Pre-orders',
    'submenu.brick-deliveries': 'Deliveries to customers',
    'submenu.brick-deliveriesShop': 'Deliveries',
    'submenu.pos-sale-history': 'Sale history',
    'submenu.pos-sale-historyAuto': 'Sales history',
    'submenu.debts-list': 'Customer debts',
    'submenu.debts-listAuto': 'Credit customers',
    'submenu.pos-other-services': 'Other services sales',
    'submenu.printing': 'Printing hub',
    'submenu.printing-new-job': 'New job',
    'submenu.printing-payments': 'Receive payment',
    'submenu.printing-history': 'History',
    'submenu.printing-rates': 'Set rates (owner)',
    'submenu.expenses-summary': 'Overview',
    'submenu.expenses-add': 'Add expense',
    'submenu.cash': 'Summary',
    'submenu.cash-new': 'New transaction',
    'submenu.cash-insights': 'Daily insights',
    'submenu.cash-sms-monitor': 'SMS monitor',
    'submenu.cash-history': 'Transaction history',
    'submenu.report-daily': 'Daily sales',
    'submenu.report-financial': 'Business summary',
    'submenu.report-weekly': 'Weekly sales',
    'submenu.report-monthly': 'Monthly profit',
    'submenu.report-printing': 'Printing & copy income',
    'submenu.report-stock': 'Stock report',
    'submenu.report-wakala': 'Wakala / cash',
    'submenu.report-loan-pack': 'Loan application pack',

    'loanPack.title': 'Loan application pack',
    'loanPack.cardDesc': 'Download a PDF summary of revenue, expenses, stock, and debts for bank or SACCO applications.',
    'loanPack.lead': 'Combines sales, expenses, inventory, and factory data into one branded PDF.',
    'loanPack.back': 'All reports',
    'loanPack.monthsLabel': 'Period',
    'loanPack.months6': 'Last 6 months',
    'loanPack.months12': 'Last 12 months',
    'loanPack.preview': 'Preview summary',
    'loanPack.downloadPdf': 'Download PDF',
    'loanPack.loading': 'Loading…',
    'loanPack.loadError': 'Could not load loan pack data.',
    'loanPack.exportError': 'Could not generate PDF.',
    'loanPack.accessDenied': 'Only owner or manager can access the loan application pack.',
    'loanPack.period': 'Period',
    'loanPack.generated': 'Generated',
    'loanPack.phone': 'Phone',
    'loanPack.pdfTitle': 'Loan Application Pack',
    'loanPack.executiveSummary': 'Executive summary',
    'loanPack.totalRevenue': 'Total recorded revenue',
    'loanPack.posRevenue': 'POS sales revenue',
    'loanPack.posProfit': 'POS gross profit',
    'loanPack.totalExpenses': 'Total expenses',
    'loanPack.netEstimate': 'Estimated net (profit − expenses)',
    'loanPack.stockValue': 'Inventory value (at cost)',
    'loanPack.stockProducts': 'Products in stock',
    'loanPack.receivables': 'Customer receivables (open)',
    'loanPack.openDebts': 'Open debt accounts',
    'loanPack.bricksNet': 'Bricks produced (net)',
    'loanPack.deliveryRevenue': 'Delivery revenue',
    'loanPack.printCollected': 'Printing income collected',
    'loanPack.monthlyBreakdown': 'Monthly breakdown',
    'loanPack.month': 'Month',
    'loanPack.expenses': 'Expenses',
    'loanPack.total': 'TOTAL',
    'loanPack.factorySection': 'Factory production & deliveries',
    'loanPack.deliveryPieces': 'Pieces delivered',
    'loanPack.expenseSplit': 'Expense split (period total)',
    'loanPack.category': 'Category',
    'loanPack.amount': 'Amount',
    'loanPack.expenseBoss': 'Owner / business',
    'loanPack.expenseStaff': 'Staff & payroll',
    'loanPack.expenseOffice': 'Office & operations',
    'loanPack.disclaimer':
      'This pack is generated from business records in cbonline app. It supports loan applications but does not replace audited financial statements, tax filings, or bank statements.',

    'settings.title': 'Settings',
    'settings.businessProfile': 'Business profile',
    'settings.notifications': 'Notifications',
    'settings.billing': 'Billing',
    'settings.password': 'Password',
    'settings.activityLog': 'Activity log',
    'settings.foot': 'Theme: use the sun/moon button at the top · profile photo · tap your avatar',
    'settings.trial': 'Trial',

    'access.title': 'Access restricted',
    'access.ownerOnly':
      'This area is for the business owner only (for example full business reports or user management). Staff can continue using stock, sales, printing, and cash as usual.',
    'access.back': 'Back to dashboard',

    'dash.greetingMorning': 'Good morning',
    'dash.greetingAfternoon': 'Good afternoon',
    'dash.greetingEvening': 'Good evening',
    'dash.quickActions': 'Quick actions',
    'dash.revenueToday': 'Revenue today',
    'dash.salesToday': 'Sales today',
    'dash.profitToday': 'Profit today',
    'dash.netToday': 'Net today',
    'dash.revenueWeek': 'Revenue week',
    'dash.profitWeek': 'Profit week',
    'dash.netWeek': 'Net week',
    'dash.bricksToday': 'Bricks today',
    'dash.readyStock': 'Ready stock',
    'dash.bricksMonth': 'Bricks month',
    'dash.damagedMonth': 'Damaged (month)',
    'dash.deliveriesToday': 'Deliveries today',
    'dash.recentProduction': 'Recent production',
    'dash.recentDeliveries': 'Recent deliveries',
    'dash.deliveries': 'Deliveries',
    'dash.counterSales': "Today's counter sales",
    'dash.welcome': 'Welcome to cbonline app',
    'dash.actions': 'Actions',
    'dash.todaysSales': "Today's sales",

    'overview.ariaLabel': 'Branch and team controls',
    'overview.title': 'Branch & team hub',
    'overview.sub': 'Dashboard numbers update for',
    'overview.subBar': 'Sales, debts, and charts update for',
    'overview.manageBranches': 'Manage branches',
    'overview.addTeam': '+ Add team member',
    'overview.searchBranch': 'Search branch',
    'overview.searchBranchPlaceholder': 'Type branch name…',
    'overview.dashboardBranch': 'Dashboard branch',
    'overview.allBranchesCombined': 'All branches (combined)',
    'overview.allBranches': 'All branches',
    'overview.selectedBranch': 'Selected branch',
    'overview.inactive': '(inactive)',
    'overview.clearFilter': 'Clear filter',
    'overview.searchTeam': 'Search team',
    'overview.searchTeamPlaceholder': 'Name or email…',
    'overview.role': 'Role',
    'overview.allRoles': 'All roles',
    'overview.staffOnly': 'Staff only',
    'overview.ownersOnly': 'Owners only',
    'overview.fullTeam': 'Full team page →',
    'overview.teamGlance': 'Team at a glance',
    'overview.loading': 'Loading…',
    'overview.memberCount': '{{count}} member(s)',
    'overview.teamLoadError': 'Could not load team.',
    'overview.colName': 'Name',
    'overview.colEmail': 'Email',
    'overview.colBranch': 'Branch',
    'overview.colRole': 'Role',
    'overview.noTeamMatch': 'No team members match your filters.',
    'overview.addSomeone': 'Add someone',
    'overview.manage': 'Manage',
    'overview.viewAllTeam': 'View all {{count}} team members →',

    'team.titleOwner': 'Team users',
    'team.titleBranch': 'My branch team',
    'team.ledeOwner': 'Manage owners, managers, and staff across all branches.',
    'team.ledeBranch': 'Coworkers at {{branch}}.',

    'exp.cat.staff.label': 'Staff payroll',
    'exp.cat.staff.hint': 'Permanent salaries or day-work pay (cement bags)',
    'exp.cat.staff.short': 'Staff',
    'exp.cat.staff.retail': 'Staff',
    'exp.cat.office.label': 'Plant costs',
    'exp.cat.office.hint': 'Fuel, maintenance, utilities, and other factory running costs',
    'exp.cat.office.short': 'Plant',
    'exp.cat.office.retail': 'Office & operations',
    'exp.cat.boss.label': 'Owner / business',
    'exp.cat.boss.hint': 'Personal or business costs for the owner',
    'exp.cat.boss.short': 'Owner',
    'exp.cat.boss.retail': 'Boss / owner',
    'exp.pay.permanent': 'Permanent staff',
    'exp.pay.permanentHint': 'Regular monthly or fixed salary',
    'exp.pay.dayWork': 'Day work',
    'exp.pay.dayWorkHint': 'Paid per cement bag used in production',
    'exp.payment.cash': 'Cash',
    'exp.payment.lipa': 'Lipa number',
    'exp.list.staff.title': 'Staff payroll',
    'exp.list.staff.lede': 'Permanent salaries and day-work pay (by cement bags).',
    'exp.list.office.title': 'Plant costs',
    'exp.list.office.lede': 'Fuel, maintenance, utilities, and other factory running costs.',
    'exp.list.boss.title': 'Owner / business expenses',
    'exp.list.boss.lede': 'Personal or business costs recorded by the owner.',
    'exp.summary.eyebrow': 'Expenses',
    'exp.summary.overview': 'Overview',
    'exp.summary.ledeFactory':
      'Summary of payroll and plant costs — today, this week, and this month. Pick a period below to see the trend.',
    'exp.summary.ledeRetail':
      'Pick day, week, or month and an anchor date. The chart shows daily totals split by Boss, Staff, and Office.',
    'exp.summary.title': 'Expenses overview',
    'exp.summary.recordCost': '+ Record expense',
    'exp.period.label': 'Period',
    'exp.period.day': 'Day',
    'exp.period.week': 'Week',
    'exp.period.month': 'Month',
    'exp.period.anchor': 'Anchor date (week/month is based on this date)',
    'exp.export.csv': 'Download CSV',
    'exp.export.pdf': 'Download PDF',
    'exp.export.exportingCsv': 'Downloading…',
    'exp.export.exportingPdf': 'PDF…',
    'exp.totals.title': 'Totals by category (TZS)',
    'exp.totals.hint': 'Tap a card to open the full list for that category.',
    'exp.totals.tapList': 'TZS · tap to open list',
    'exp.trend.title': 'Spending trend',
    'exp.trend.ledeFactory':
      'Daily stacked bars — different colors for payroll, plant costs, and owner.',
    'exp.trend.ledeRetail':
      'Stacked bars per day — bar height is the daily total; colors show Boss vs Staff vs Office.',
    'exp.trend.dayTotal': 'Day total: TZS {{amount}}',
    'exp.chart.empty': 'No expenses in this period — chart will appear when you add entries.',
    'exp.hub.aria': 'Today and week summary',
    'exp.hub.title': 'Today & week',
    'exp.hub.lede': 'Operating costs (payroll + plant): today TZS {{today}} · week TZS {{week}}',
    'exp.hub.today': 'Today',
    'exp.hub.week': 'Week',
    'exp.hub.viewList': 'View list →',
    'exp.hub.payStaff': '+ Pay staff',
    'exp.hub.plantCost': '+ Plant cost',
    'exp.hub.otherCost': '+ Other expense',
    'exp.hub.recent': 'Recent payments',
    'exp.hub.loading': 'Loading expenses…',
    'exp.hub.loadError': 'Could not load expenses.',
    'exp.add.title': 'Add expense',
    'exp.add.ledeFactory':
      'Payroll: choose permanent (fixed amount) or day work (by cement bags).',
    'exp.add.ledeBar': 'Record pub expenses — all fields are required.',
    'exp.add.ledeRetail': 'All fields are required. Pick a date quickly or choose another day.',
    'exp.add.categoryTitle': 'Expense type',
    'exp.add.staffPayTitle': 'Payroll type',
    'exp.add.dateTitle': 'Expense date',
    'exp.add.dateToday': 'Today',
    'exp.add.dateYesterday': 'Yesterday',
    'exp.add.dateDay2': '2 days ago',
    'exp.add.dateCustom': 'Other date',
    'exp.add.pickDate': 'Pick date',
    'exp.add.dateSelected': 'Selected:',
    'exp.add.dayWorkTitle': 'Day-work pay',
    'exp.add.loadingProduction': 'Loading cement bags from production…',
    'exp.add.productionLine': 'Production {{date}}: {{bags}} cement bags{{batch}}',
    'exp.add.noBatch': ' — no batch recorded',
    'exp.add.batchCount': ' ({{count}} batch)',
    'exp.add.useProductionBags': 'Use production bags',
    'exp.add.noProductionData': 'No production data for this date — enter bags manually.',
    'exp.add.bagsToPay': 'Bags to pay',
    'exp.add.ratePerBag': 'Pay per bag (TZS)',
    'exp.add.payTotal': 'Total pay',
    'exp.add.descStaff': 'Details / name',
    'exp.add.descOther': 'What was paid',
    'exp.add.amount': 'Amount (TZS)',
    'exp.add.paymentTitle': 'Payment',
    'exp.add.lipaRef': 'Lipa number / reference',
    'exp.add.evidenceTitle': 'Payment evidence (optional)',
    'exp.add.sms': 'Transaction SMS',
    'exp.add.receiptFile': 'Receipt photo or PDF',
    'exp.add.notes': 'Additional notes',
    'exp.add.saving': 'Saving…',
    'exp.add.save': 'Save expense',
    'exp.add.remove': 'Remove',
    'exp.add.pdfSelected': 'PDF selected: {{name}}',
    'exp.add.previewAlt': 'Preview',
    'exp.err.description': 'Description is required.',
    'exp.err.staffPayType': 'Choose a staff pay type.',
    'exp.err.cementBags': 'Enter cement bags to pay.',
    'exp.err.cementRate': 'Enter pay per bag.',
    'exp.err.amountCalc': 'Pay total could not be calculated.',
    'exp.err.amount': 'Enter a valid amount (TZS).',
    'exp.err.date': 'Pick a date.',
    'exp.err.dateFuture': 'Date cannot be in the future.',
    'exp.err.notes': 'Notes are required.',
    'exp.err.lipaRef': 'Lipa number / reference is required.',
    'exp.err.save': 'Could not save expense.',
    'exp.ph.dayWorkDesc': 'E.g. Evening crew — today\'s batch',
    'exp.ph.factoryDesc': 'E.g. January payroll, Hassan fundi…',
    'exp.ph.retailDesc': 'What was paid for?',
    'exp.ph.lipaRef': 'E.g. 07XX… or transaction ID',
    'exp.ph.sms': 'Paste M-Pesa / bank SMS if available…',
    'exp.ph.dayWorkNotes': 'E.g. Juma, Petro — used 12 bags in production…',
    'exp.ph.factoryNotes': 'E.g. receipt #45, paid via M-Pesa…',
    'exp.ph.retailNotes': 'Receipt, supplier, context…',
    'exp.list.loading': 'Loading…',
    'exp.list.loadError': 'Could not load',
    'exp.list.emptyTitle': 'No expenses yet',
    'exp.list.emptyText': 'Add an expense to see it listed here.',
    'exp.list.records': '{{count}} record(s)',
    'exp.list.viewEvidence': 'View SMS / photo',
    'exp.list.view': 'View',
    'exp.list.date': 'Date',
    'exp.list.by': 'By',
    'exp.list.payment': 'Payment',
    'exp.list.ref': 'Ref',
    'exp.list.notes': 'Notes',
    'exp.list.evidence': 'Evidence',
    'exp.list.type': 'Type',
    'exp.list.amount': 'Amount (TZS)',
    'exp.list.description': 'Description',
    'exp.list.cementLine': '{{bags}} bags × TZS {{rate}}',
    'exp.list.productionRef': '(production: {{bags}} bags)',
    'exp.list.smsTitle': 'Transaction SMS',
    'exp.list.receiptTitle': 'Photo / receipt',
    'exp.list.openPdf': 'Open PDF',
    'exp.list.evidenceAlt': 'Payment evidence',
    'exp.list.close': 'Close',
    'exp.list.addExpense': 'Add expense',
    'exp.list.downloadSms': 'Download SMS',
    'exp.list.downloadFile': 'Download file',
    'exp.list.downloadFailed': 'Download failed.',
    'exp.list.pdfError': 'Could not create PDF.',
    'exp.list.exportTitle': 'Expenses — {{category}}',
    'exp.common.refresh': 'Refresh',
    'exp.common.loading': 'Loading…',
    'exp.common.loadSummaryError': 'Could not load summary.',
    'exp.common.exportError': 'Could not export.',

    'factory.setupBrickTitle': 'Set up brick types first',
    'factory.setupBrickText':
      'Before production batches, define the bricks or pavers you make. This links stock, POS, and deliveries.',
    'factory.setupBrickCta': 'Brick types',
  },
  sw: {
    'lang.en': 'Kiingereza',
    'lang.sw': 'Kiswahili',
    'lang.label': 'Lugha',
    'lang.switch': 'Badilisha lugha',

    'theme.appearance': 'Mwonekano',
    'theme.light': 'Mwanga',
    'theme.dark': 'Giza',
    'theme.system': 'Kifaa',
    'theme.toggle': 'Mwanga au giza',

    'role.owner': 'Mmiliki',
    'role.manager': 'Meneja',
    'role.employee': 'Mfanyakazi',

    'topbar.dashboard': 'Dashibodi',
    'topbar.openMenu': 'Fungua menyu',
    'topbar.loggedIn': 'Umeingia:',
    'topbar.session': 'Kipindi',
    'topbar.notifications': 'Arifa',
    'topbar.unreadNotifications': 'Arifa {{count}} hazijasomwa',
    'topbar.markAllRead': 'Weka zote zimesomwa',
    'topbar.noNotifications': 'Hakuna arifa bado.',
    'topbar.logout': 'Toka',
    'topbar.changePhoto': 'Badilisha picha ya wasifu',

    'menu.overview': 'Muhtasari',
    'menu.users': 'Matawi na Timu',
    'menu.usersBranch': 'Timu ya tawi langu',
    'menu.stock': 'Mali ghafi',
    'menu.orders': 'Maagizo ya vifaa',
    'menu.factoryStock': 'Hifadhi',
    'menu.ordersShop': 'Maagizo',
    'menu.stockShop': 'Usimamizi wa stock',
    'menu.productsAuto': 'Spare parts',
    'menu.openingStockAuto': 'Stock ya mwanzo',
    'menu.manualAuto': 'Mwongozo',
    'menu.ordersAuto': 'Manunuzi',
    'menu.stockAuto': 'Stock',
    'menu.brick': 'Uzalishaji',
    'menu.pos': 'Mauzo (POS)',
    'menu.posAuto': 'Mauzo',
    'menu.posFactory': 'Mauzo (POS)',
    'menu.printing': 'Uchapishaji',
    'menu.expenses': 'Matumizi',
    'menu.expensesFactory': 'Matumizi',
    'menu.cash': 'Daftari la wakala',
    'menu.reports': 'Ripoti',
    'menu.settings': 'Mipangilio',

    'submenu.branches-list': 'Matawi',
    'submenu.users-list': 'Watumiaji wote',
    'submenu.users-listBranch': 'Wafanyakazi',
    'submenu.users-add': 'Ongeza mtumiaji',
    'submenu.raw-materials-overview': 'Muhtasari',
    'submenu.add-raw-material': 'Ongeza vifaa',
    'submenu.add-raw-material-category': 'Ongeza kategoria',
    'submenu.factory-suppliers': 'Ongeza wasambazaji',
    'submenu.orders-make': 'Agiza vifaa',
    'submenu.orders-tracking': 'Ufuatiliaji wa oda',
    'submenu.orders-makeShop': 'Agiza bidhaa',
    'submenu.orders-list': 'Orodha ya maagizo',
    'submenu.auto-products-record': 'Sajili spare part',
    'submenu.auto-products-opening': 'Stock ya mwanzo',
    'submenu.auto-products-categories': 'Kategoria za spare',
    'submenu.auto-products-brands': 'Brand',
    'submenu.auto-products-units': 'Units',
    'submenu.auto-products-list': 'Orodha ya spare',
    'submenu.orders-makeAuto': 'Agiza mzigo',
    'submenu.auto-suppliers': 'Wasambazaji',
    'submenu.orders-listAuto': 'Historia ya manunuzi',
    'submenu.orders-trackingAuto': 'Pokea na fuatilia',
    'submenu.shop-customer-docs': 'Nukuu na ankara',
    'submenu.factory-stock-overview': 'Muhtasari wa stock',
    'submenu.stock-alerts': 'Tahadhari za stock chini',
    'submenu.stock-add': 'Ongeza bidhaa',
    'submenu.stock-list': 'Orodha ya bidhaa',
    'submenu.stock-addAuto': 'Ongeza spare part',
    'submenu.stock-listAuto': 'Catalog ya spare',
    'submenu.stock-alertsAuto': 'Stock chini',
    'submenu.stock-pending': 'Zinazosubiri uidhinishaji',
    'submenu.pharmacy-expiry': 'Muda wa kuisha',
    'submenu.brick-catalog': 'Aina za tofali',
    'submenu.brick-production': 'Batch za uzalishaji',
    'submenu.damaged-products': 'Tofali zilizoharibika',
    'submenu.damaged-productsAuto': 'Spare zilizoharibika',
    'submenu.auto-inventory': 'Orodha ya stock',
    'submenu.pos-sale-products': 'Uza bidhaa',
    'submenu.pos-sale-productsAuto': 'Uza spare',
    'submenu.brick-pre-orders': 'Maagizo ya mapema',
    'submenu.brick-deliveries': 'Usafirishaji kwa wateja',
    'submenu.brick-deliveriesShop': 'Usafirishaji',
    'submenu.pos-sale-history': 'Historia ya mauzo',
    'submenu.pos-sale-historyAuto': 'Historia ya mauzo',
    'submenu.debts-list': 'Madeni ya wateja',
    'submenu.debts-listAuto': 'Wateja wa deni',
    'submenu.pos-other-services': 'Mauzo ya huduma nyingine',
    'submenu.printing': 'Kituo cha uchapishaji',
    'submenu.printing-new-job': 'Kazi mpya',
    'submenu.printing-payments': 'Pokea malipo',
    'submenu.printing-history': 'Historia',
    'submenu.printing-rates': 'Weka bei (mmiliki)',
    'submenu.expenses-summary': 'Muhtasari',
    'submenu.expenses-add': 'Ongeza matumizi',
    'submenu.cash': 'Muhtasari',
    'submenu.cash-new': 'Miamala mpya',
    'submenu.cash-insights': 'Muhtasari wa kila siku',
    'submenu.cash-sms-monitor': 'Ufuatiliaji wa SMS',
    'submenu.cash-history': 'Historia ya miamala',
    'submenu.report-daily': 'Mauzo ya kila siku',
    'submenu.report-financial': 'Muhtasari wa biashara',
    'submenu.report-weekly': 'Mauzo ya wiki',
    'submenu.report-monthly': 'Faida ya mwezi',
    'submenu.report-printing': 'Mapato ya uchapishaji',
    'submenu.report-stock': 'Ripoti ya stock',
    'submenu.report-wakala': 'Wakala / fedha',
    'submenu.report-loan-pack': 'Pakiti ya mkopo',

    'loanPack.title': 'Pakiti ya ombi la mkopo',
    'loanPack.cardDesc': 'Pakua PDF ya mapato, matumizi, stock na deni kwa benki au SACCO.',
    'loanPack.lead': 'Inaunganisha mauzo, matumizi, hifadhi na data ya kiwanda katika PDF moja.',
    'loanPack.back': 'Ripoti zote',
    'loanPack.monthsLabel': 'Kipindi',
    'loanPack.months6': 'Miezi 6 iliyopita',
    'loanPack.months12': 'Miezi 12 iliyopita',
    'loanPack.preview': 'Angalia muhtasari',
    'loanPack.downloadPdf': 'Pakua PDF',
    'loanPack.loading': 'Inapakia…',
    'loanPack.loadError': 'Imeshindwa kupakia data ya mkopo.',
    'loanPack.exportError': 'Imeshindwa kutengeneza PDF.',
    'loanPack.accessDenied': 'Mmiliki au meneja pekee ndiye anaweza kufikia pakiti ya mkopo.',
    'loanPack.period': 'Kipindi',
    'loanPack.generated': 'Imetengenezwa',
    'loanPack.phone': 'Simu',
    'loanPack.pdfTitle': 'Pakiti ya Ombi la Mkopo',
    'loanPack.executiveSummary': 'Muhtasari',
    'loanPack.totalRevenue': 'Jumla ya mapato yaliyorekodiwa',
    'loanPack.posRevenue': 'Mapato ya mauzo (POS)',
    'loanPack.posProfit': 'Faida ya POS',
    'loanPack.totalExpenses': 'Jumla ya matumizi',
    'loanPack.netEstimate': 'Safi inayokadiriwa (faida − matumizi)',
    'loanPack.stockValue': 'Thamani ya stock (gharama)',
    'loanPack.stockProducts': 'Bidhaa kwenye stock',
    'loanPack.receivables': 'Deni la wateja (wazi)',
    'loanPack.openDebts': 'Akaunti za deni wazi',
    'loanPack.bricksNet': 'Tofali zilizozalishwa (safi)',
    'loanPack.deliveryRevenue': 'Mapato ya usafirishaji',
    'loanPack.printCollected': 'Mapato ya uchapishaji',
    'loanPack.monthlyBreakdown': 'Muhtasari wa kila mwezi',
    'loanPack.month': 'Mwezi',
    'loanPack.expenses': 'Matumizi',
    'loanPack.total': 'JUMLA',
    'loanPack.factorySection': 'Uzalishaji na usafirishaji (kiwanda)',
    'loanPack.deliveryPieces': 'Vipande vilivyosafirishwa',
    'loanPack.expenseSplit': 'Mgawanyo wa matumizi (jumla ya kipindi)',
    'loanPack.category': 'Kategoria',
    'loanPack.amount': 'Kiasi',
    'loanPack.expenseBoss': 'Mmiliki / biashara',
    'loanPack.expenseStaff': 'Wafanyakazi / mishahara',
    'loanPack.expenseOffice': 'Ofisi na uendeshaji',
    'loanPack.disclaimer':
      'Pakiti hii imetengenezwa kutoka rekodi za biashara kwenye cbonline app. Inasaidia ombi la mkopo lakini haibadilishi taarifa za ukaguzi, kodi, au taarifa za benki.',

    'settings.title': 'Mipangilio',
    'settings.businessProfile': 'Wasifu wa biashara',
    'settings.notifications': 'Arifa',
    'settings.billing': 'Malipo / bili',
    'settings.password': 'Nenosiri',
    'settings.activityLog': 'Kumbukumbu za shughuli',
    'settings.foot': 'Mwanga/giza · kitufe cha jua/mwezi juu · picha · bonyeza avatar',
    'settings.trial': 'Jaribio',

    'access.title': 'Ufikiaji umepunguzwa',
    'access.ownerOnly':
      'Eneo hili ni la mmiliki wa biashara pekee (kwa mfano ripoti kamili au usimamizi wa watumiaji). Wafanyakazi wanaendelea kutumia stock, mauzo, uchapishaji na fedha kama kawaida.',
    'access.back': 'Rudi kwenye dashibodi',

    'dash.greetingMorning': 'Habari za asubuhi',
    'dash.greetingAfternoon': 'Habari za mchana',
    'dash.greetingEvening': 'Habari za jioni',
    'dash.quickActions': 'Vitendo vya haraka',
    'dash.revenueToday': 'Mapato leo',
    'dash.salesToday': 'Mauzo leo',
    'dash.profitToday': 'Faida leo',
    'dash.netToday': 'Safi leo',
    'dash.revenueWeek': 'Mapato wiki',
    'dash.profitWeek': 'Faida wiki',
    'dash.netWeek': 'Safi wiki',
    'dash.bricksToday': 'Tofali leo',
    'dash.readyStock': 'Stock tayari',
    'dash.bricksMonth': 'Tofali mwezi',
    'dash.damagedMonth': 'Zilizoharibika (mwezi)',
    'dash.deliveriesToday': 'Usafirishaji leo',
    'dash.recentProduction': 'Uzalishaji wa hivi karibuni',
    'dash.recentDeliveries': 'Usafirishaji wa hivi karibuni',
    'dash.deliveries': 'Usafirishaji',
    'dash.counterSales': 'Mauzo ya leo (kaunta)',
    'dash.welcome': 'Karibu kwenye cbonline app',
    'dash.actions': 'Vitendo',
    'dash.todaysSales': 'Mauzo ya leo',

    'overview.ariaLabel': 'Udhibiti wa tawi na timu',
    'overview.title': 'Tawi na timu',
    'overview.sub': 'Namba za dashibodi zinaonyesha',
    'overview.subBar': 'Mauzo, deni na chati zinaonyesha',
    'overview.manageBranches': 'Simamia matawi',
    'overview.addTeam': '+ Ongeza mfanyakazi',
    'overview.searchBranch': 'Tafuta tawi',
    'overview.searchBranchPlaceholder': 'Andika jina la tawi…',
    'overview.dashboardBranch': 'Tawi la dashibodi',
    'overview.allBranchesCombined': 'Matawi yote (pamoja)',
    'overview.allBranches': 'Matawi yote',
    'overview.selectedBranch': 'Tawi lililochaguliwa',
    'overview.inactive': '(haijatumika)',
    'overview.clearFilter': 'Futa kichujio',
    'overview.searchTeam': 'Tafuta timu',
    'overview.searchTeamPlaceholder': 'Jina au barua pepe…',
    'overview.role': 'Wadhifa',
    'overview.allRoles': 'Wadhifa wote',
    'overview.staffOnly': 'Wafanyakazi tu',
    'overview.ownersOnly': 'Wamiliki tu',
    'overview.fullTeam': 'Ukurasa kamili wa timu →',
    'overview.teamGlance': 'Timu kwa muhtasari',
    'overview.loading': 'Inapakia…',
    'overview.memberCount': 'Wanachama {{count}}',
    'overview.teamLoadError': 'Imeshindwa kupakia timu.',
    'overview.colName': 'Jina',
    'overview.colEmail': 'Barua pepe',
    'overview.colBranch': 'Tawi',
    'overview.colRole': 'Wadhifa',
    'overview.noTeamMatch': 'Hakuna wanachama wanaolingana na vichujio.',
    'overview.addSomeone': 'Ongeza mtu',
    'overview.manage': 'Simamia',
    'overview.viewAllTeam': 'Ona wanachama {{count}} wote →',

    'team.titleOwner': 'Watumiaji wa timu',
    'team.titleBranch': 'Timu ya tawi langu',
    'team.ledeOwner': 'Simamia wamiliki, weneja na wafanyakazi katika matawi yote.',
    'team.ledeBranch': 'Wafanyakazi wa {{branch}}.',

    'exp.cat.staff.label': 'Mishahara ya wafanyakazi',
    'exp.cat.staff.hint': 'Mishahara wa kudumu au malipo ya kazi ya siku (mifuko ya cement)',
    'exp.cat.staff.short': 'Wafanyakazi',
    'exp.cat.staff.retail': 'Wafanyakazi',
    'exp.cat.office.label': 'Gharama za kiwanda',
    'exp.cat.office.hint': 'Mafuta, matengenezo, umeme na gharama nyingine za uendeshaji',
    'exp.cat.office.short': 'Kiwanda',
    'exp.cat.office.retail': 'Ofisi na uendeshaji',
    'exp.cat.boss.label': 'Mwenye kiwanda / biashara',
    'exp.cat.boss.hint': 'Gharama za kibinafsi au za biashara za mmiliki',
    'exp.cat.boss.short': 'Mwenye kiwanda',
    'exp.cat.boss.retail': 'Mmiliki',
    'exp.pay.permanent': 'Wafanyakazi wa kudumu',
    'exp.pay.permanentHint': 'Mishahara wa kila mwezi au kiasi cha kawaida',
    'exp.pay.dayWork': 'Kazi ya siku',
    'exp.pay.dayWorkHint': 'Malipo kwa kila mfuko wa cement uliotumika uzalishajini',
    'exp.payment.cash': 'Taslimu',
    'exp.payment.lipa': 'Lipa namba',
    'exp.list.staff.title': 'Mishahara ya wafanyakazi',
    'exp.list.staff.lede': 'Mishahara wa kudumu na malipo ya kazi ya siku (kwa mifuko ya cement).',
    'exp.list.office.title': 'Gharama za kiwanda',
    'exp.list.office.lede': 'Mafuta, matengenezo, umeme na gharama nyingine za uendeshaji wa kiwanda.',
    'exp.list.boss.title': 'Gharama za mwenye kiwanda',
    'exp.list.boss.lede': 'Gharama za kibinafsi au za biashara zilizorekodiwa na mmiliki.',
    'exp.summary.eyebrow': 'Matumizi',
    'exp.summary.overview': 'Muhtasari',
    'exp.summary.ledeFactory':
      'Muhtasari wa mishahara na gharama za kiwanda — leo, wiki, na mwezi. Chagua kipindi chini kuona mwenendo.',
    'exp.summary.ledeRetail':
      'Chagua siku, wiki au mwezi na tarehe ya kuanzia. Chati inaonyesha jumla za kila siku kwa Mmiliki, Wafanyakazi na Ofisi.',
    'exp.summary.title': 'Muhtasari wa matumizi',
    'exp.summary.recordCost': '+ Rekodi gharama',
    'exp.period.label': 'Kipindi',
    'exp.period.day': 'Siku',
    'exp.period.week': 'Wiki',
    'exp.period.month': 'Mwezi',
    'exp.period.anchor': 'Tarehe ya kuanzia (wiki/mwezi hutegemea tarehe hii)',
    'exp.export.csv': 'Pakua CSV',
    'exp.export.pdf': 'Pakua PDF',
    'exp.export.exportingCsv': 'Inapakua…',
    'exp.export.exportingPdf': 'PDF…',
    'exp.totals.title': 'Jumla kwa aina (TZS)',
    'exp.totals.hint': 'Bofya kadi ili kuona orodha kamili ya kila aina.',
    'exp.totals.tapList': 'TZS · angalia orodha →',
    'exp.trend.title': 'Mwenendo wa gharama',
    'exp.trend.ledeFactory':
      'Vipande vya kila siku — rangi tofauti kwa mishahara, gharama za kiwanda, na mwenye kiwanda.',
    'exp.trend.ledeRetail':
      'Vipande vilivyojumuishwa kwa siku — urefu ni jumla ya siku; rangi zinaonyesha Mmiliki dhidi ya Wafanyakazi dhidi ya Ofisi.',
    'exp.trend.dayTotal': 'Jumla ya siku: TZS {{amount}}',
    'exp.chart.empty': 'Hakuna matumizi katika kipindi hiki — chati itaonekana unapoongeza rekodi.',
    'exp.hub.aria': 'Muhtasari wa leo na wiki',
    'exp.hub.title': 'Leo na wiki',
    'exp.hub.lede': 'Gharama za uendeshaji (mishahara + kiwanda): leo TZS {{today}} · wiki TZS {{week}}',
    'exp.hub.today': 'Leo',
    'exp.hub.week': 'Wiki',
    'exp.hub.viewList': 'Angalia orodha →',
    'exp.hub.payStaff': '+ Lipa wafanyakazi',
    'exp.hub.plantCost': '+ Gharama ya kiwanda',
    'exp.hub.otherCost': '+ Gharama nyingine',
    'exp.hub.recent': 'Malipo ya hivi karibuni',
    'exp.hub.loading': 'Inapakia matumizi…',
    'exp.hub.loadError': 'Imeshindwa kupakia matumizi.',
    'exp.add.title': 'Rekodi gharama',
    'exp.add.ledeFactory':
      'Mishahara: chagua wa kudumu (kiasi cha kawaida) au kazi ya siku (kwa mifuko ya cement).',
    'exp.add.ledeBar': 'Rekodi gharama za pub — sehemu zote zinahitajika.',
    'exp.add.ledeRetail': 'Sehemu zote zinahitajika. Chagua tarehe haraka au siku nyingine.',
    'exp.add.categoryTitle': 'Aina ya gharama',
    'exp.add.staffPayTitle': 'Aina ya mishahara',
    'exp.add.dateTitle': 'Tarehe ya gharama',
    'exp.add.dateToday': 'Leo',
    'exp.add.dateYesterday': 'Jana',
    'exp.add.dateDay2': 'Juzi',
    'exp.add.dateCustom': 'Tarehe nyingine',
    'exp.add.pickDate': 'Chagua tarehe',
    'exp.add.dateSelected': 'Imechaguliwa:',
    'exp.add.dayWorkTitle': 'Malipo ya kazi ya siku',
    'exp.add.loadingProduction': 'Inatafuta mifuko ya cement kwenye uzalishaji…',
    'exp.add.productionLine': 'Uzalishaji {{date}}: {{bags}} mifuko ya cement{{batch}}',
    'exp.add.noBatch': ' — hakuna batch iliyorekodiwa',
    'exp.add.batchCount': ' (batch {{count}})',
    'exp.add.useProductionBags': 'Tumia mifuko ya uzalishaji',
    'exp.add.noProductionData': 'Hakuna data ya uzalishaji kwa tarehe hii — weka mifuko kwa mkono.',
    'exp.add.bagsToPay': 'Mifuko ya kulipia',
    'exp.add.ratePerBag': 'Malipo kwa mfuko (TZS)',
    'exp.add.payTotal': 'Jumla ya malipo',
    'exp.add.descStaff': 'Maelezo / jina',
    'exp.add.descOther': 'Kilicholipwa',
    'exp.add.amount': 'Kiasi (TZS)',
    'exp.add.paymentTitle': 'Malipo',
    'exp.add.lipaRef': 'Namba ya Lipa / kumbukumbu',
    'exp.add.evidenceTitle': 'Ushahidi wa malipo (si lazima)',
    'exp.add.sms': 'SMS ya muamala',
    'exp.add.receiptFile': 'Picha au PDF ya risiti / screenshot',
    'exp.add.notes': 'Maelezo ya ziada',
    'exp.add.saving': 'Inahifadhi…',
    'exp.add.save': 'Hifadhi gharama',
    'exp.add.remove': 'Ondoa',
    'exp.add.pdfSelected': 'PDF imechaguliwa: {{name}}',
    'exp.add.previewAlt': 'Onyesho',
    'exp.err.description': 'Andika kilicholipwa.',
    'exp.err.staffPayType': 'Chagua aina ya malipo ya wafanyakazi.',
    'exp.err.cementBags': 'Weka mifuko ya cement ya kulipia.',
    'exp.err.cementRate': 'Weka malipo kwa kila mfuko.',
    'exp.err.amountCalc': 'Jumla ya malipo haijakokotoa.',
    'exp.err.amount': 'Weka kiasi halali (TZS).',
    'exp.err.date': 'Chagua tarehe.',
    'exp.err.dateFuture': 'Tarehe haiwezi kuwa baadaye.',
    'exp.err.notes': 'Andika maelezo (mf. risiti, majina).',
    'exp.err.lipaRef': 'Weka namba ya Lipa au kumbukumbu ya malipo.',
    'exp.err.save': 'Imeshindwa kuhifadhi gharama.',
    'exp.ph.dayWorkDesc': 'Mf. Wafanyakazi wa jioni — batch ya leo',
    'exp.ph.factoryDesc': 'Mf. Mishahara Januari, Hassan fundi…',
    'exp.ph.retailDesc': 'Kilicholipwa ni nini?',
    'exp.ph.lipaRef': 'Mf. 07XX… au namba ya muamala',
    'exp.ph.sms': 'Bandika SMS ya M-Pesa / benki ikiwepo…',
    'exp.ph.dayWorkNotes': 'Mf. Juma, Petro — walitumia mifuko 12 kwenye uzalishaji…',
    'exp.ph.factoryNotes': 'Mf. risiti #45, malipo kwa M-Pesa…',
    'exp.ph.retailNotes': 'Risiti, msambazaji, muktadha…',
    'exp.list.loading': 'Inapakia…',
    'exp.list.loadError': 'Imeshindwa kupakia',
    'exp.list.emptyTitle': 'Hakuna matumizi bado',
    'exp.list.emptyText': 'Ongeza gharama ili kuiona hapa.',
    'exp.list.records': 'Rekodi {{count}}',
    'exp.list.viewEvidence': 'Angalia SMS / picha',
    'exp.list.view': 'Angalia',
    'exp.list.date': 'Tarehe',
    'exp.list.by': 'Na',
    'exp.list.payment': 'Malipo',
    'exp.list.ref': 'Kumb.',
    'exp.list.notes': 'Maelezo',
    'exp.list.evidence': 'Ushahidi',
    'exp.list.type': 'Aina',
    'exp.list.amount': 'Kiasi (TZS)',
    'exp.list.description': 'Maelezo',
    'exp.list.cementLine': '{{bags}} mifuko × TZS {{rate}}',
    'exp.list.productionRef': '(uzalishaji: {{bags}} mifuko)',
    'exp.list.smsTitle': 'SMS ya muamala',
    'exp.list.receiptTitle': 'Picha / risiti',
    'exp.list.openPdf': 'Fungua PDF',
    'exp.list.evidenceAlt': 'Ushahidi wa malipo',
    'exp.list.close': 'Funga',
    'exp.list.addExpense': 'Ongeza gharama',
    'exp.list.downloadSms': 'Pakua SMS',
    'exp.list.downloadFile': 'Pakua faili',
    'exp.list.downloadFailed': 'Upakuaji umeshindwa.',
    'exp.list.pdfError': 'Imeshindwa kutengeneza PDF.',
    'exp.list.exportTitle': 'Matumizi — {{category}}',
    'exp.common.refresh': 'Onyesha upya',
    'exp.common.loading': 'Inapakia…',
    'exp.common.loadSummaryError': 'Imeshindwa kupakia muhtasari.',
    'exp.common.exportError': 'Imeshindwa kupakua.',

    'factory.setupBrickTitle': 'Weka aina za matofali kwanza',
    'factory.setupBrickText':
      'Kabla ya batch za uzalishaji, fafanua tofali au pavers mnazozalisha. Hii inaunganisha stock, POS na usafirishaji.',
    'factory.setupBrickCta': 'Aina za tofali',
  },
};

/** @type {Record<AppLanguage, Record<string, string>>} */
export const STRINGS = {
  en: { ...CORE_STRINGS.en, ...PUBLIC_STRINGS_EN },
  sw: { ...CORE_STRINGS.sw, ...PUBLIC_STRINGS_SW },
};

export const LANGUAGE_OPTIONS = [
  { value: 'en', labelKey: 'lang.en' },
  { value: 'sw', labelKey: 'lang.sw' },
];

export function translate(lang, key, vars = {}) {
  const table = STRINGS[lang] || STRINGS.en;
  let text = table[key] ?? STRINGS.en[key] ?? key;
  Object.entries(vars).forEach(([k, v]) => {
    text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, 'g'), String(v));
  });
  return text;
}
